import { disablePostComments } from '../../../actions/disable-post-comments';
import { enablePostComments } from '../../../actions/enable-post-comments';
import { showInviteDialog, showPostDeleteDialog } from '../../../actions/one-app';
import { pinPost } from '../../../actions/pin-post';
import { subscribe } from '../../../actions/subscribe';
import { unpinPost } from '../../../actions/unpin-post';
import { unsubscribe } from '../../../actions/unsubscribe';
import messages, {
  POST_UNPIN,
  POST_PIN,
  POST_DISABLE_COMMENTING,
  POST_ENABLE_COMMENTING,
  POST_SUBSCRIBED,
  POST_UNSUBSCRIBED,
} from '../../../components/message/messages';
import { getPostSlugById } from '../../../selectors/post-selectors';
import { navigateToBlog } from '../../../services/navigate-to-section';
import { push } from '../../../services/router-utils';
import { POST_ACTION_SHEET_VALUES, CATEGORY_ACTION_SHEET_VALUE } from '../constants';
import createMessageHandler from './create-message-hander';

export default createMessageHandler({
  [POST_ACTION_SHEET_VALUES.DELETE]: showPostDeleteDialog,

  [POST_ACTION_SHEET_VALUES.EDIT]: ({ message }) => (dispatch, getState) => {
    const slug = getPostSlugById(getState(), message.data.value.postId);
    navigateToBlog(`/${slug}/edit`);
  },

  [POST_ACTION_SHEET_VALUES.PIN]: ({ message, environment: { showMessage } }) => dispatch =>
    dispatch(pinPost(message.data.value.postId)).then(() =>
      showMessage(messages[POST_PIN].content(), messages[POST_PIN].type),
    ),

  [POST_ACTION_SHEET_VALUES.UNPIN]: ({ message, environment: { showMessage } }) => dispatch =>
    dispatch(unpinPost(message.data.value.postId)).then(() =>
      showMessage(messages[POST_UNPIN].content(), messages[POST_UNPIN].type),
    ),

  [POST_ACTION_SHEET_VALUES.ENABLE_COMMENTING]: ({ message, environment: { showMessage } }) => dispatch =>
    dispatch(enablePostComments(message.data.value.postId)).then(() =>
      showMessage(messages[POST_ENABLE_COMMENTING].content(), messages[POST_ENABLE_COMMENTING].type),
    ),

  [POST_ACTION_SHEET_VALUES.DISABLE_COMMENTING]: ({ message, environment: { showMessage } }) => dispatch =>
    dispatch(disablePostComments(message.data.value.postId)).then(() =>
      showMessage(messages[POST_DISABLE_COMMENTING].content(), messages[POST_DISABLE_COMMENTING].type),
    ),

  [POST_ACTION_SHEET_VALUES.FOLLOW]: ({ message, environment: { showMessage } }) => dispatch =>
    dispatch(subscribe({ _id: message.data.value.postId, type: 'post' })).then(() =>
      showMessage(messages[POST_SUBSCRIBED].content(), messages[POST_SUBSCRIBED].type),
    ),

  [POST_ACTION_SHEET_VALUES.UNFOLLOW]: ({ message, environment: { showMessage } }) => dispatch =>
    dispatch(unsubscribe({ _id: message.data.value.postId, type: 'post' })).then(() =>
      showMessage(messages[POST_UNSUBSCRIBED].content(), messages[POST_UNSUBSCRIBED].type),
    ),

  [POST_ACTION_SHEET_VALUES.SHARE]: () => showInviteDialog(),

  [CATEGORY_ACTION_SHEET_VALUE]: ({ message }) => push(message.data.value.path),
});
